import React, { useContext } from "react";
import { createPortal } from "react-dom";
import { CartContext } from "./CartContext";

export default function CartBar({ showCart, onClose }) {
  const { cart, updateQuantity, removeItem } = useContext(CartContext);

  //if (!showCart) return null; // hide when not open

  // Make sure cart is always an array
  const safeCart = cart ? Object.values(cart) : [];

  // Total items and price
  const totalItems = safeCart.length;
  const totalPrice = safeCart.reduce(
    (acc, item) => acc + parseFloat(item.salePrice) * item.quantity,
    0
  );

  return createPortal(
    <>
      {/* Overlay */}
      <div className="cart-overlay" onClick={onClose}></div>

      {/* Drawer */}
    <div className={`cart-bar ${showCart ? "show" : ""}`} style={{ overflow: "auto" }}>
      <div className="cart-header">
        <h3 className="cart-heading">MY CART ({totalItems} ITEMS)</h3>
        <div className="close-cart" onClick={onClose}>
          <i className="fa-regular fa-circle-xmark"></i>
        </div>
      </div>

      <div className="product-area">
        {safeCart.map((item, index) => {
          const cart_key = `${item.product_id}_${item.color}_${item.size}`;
          
         return <div className="product-item" key={index}>
            <div className="product-detail">
              <div className="product-thumb">
                <img src={item.product_image} alt="product-thumb" />
              </div>
              <div className="item-wrapper">
                <span className="product-name">{item.product_title}</span>
                <div className="item-wrapper">
                  <span className="product-variation">
                    <span className="color">{item.color ?? "N/A"} /</span>
                    <span className="size">{item.size ?? "N/A"}</span>
                  </span>
                </div>
                <div className="item-wrapper">
                  <span className="product-qnty">{item.quantity} ×</span>
                  <span className="product-price">${parseFloat(item.salePrice).toFixed(2)}</span>
                </div>
              </div>
            </div>

            <div className="cart-edit">
              <div className="quantity-edit">
                <button className="button minus" onClick={() => updateQuantity(cart_key, item.quantity - 1)}>
                  <i className="fa-solid fa-minus"></i>
                </button>
                <input type="text" className="input" value={item.quantity} readOnly />
                <button className="button plus" onClick={() => updateQuantity(cart_key, item.quantity + 1)}>
                  <i className="fa-solid fa-plus"></i>
                </button>
              </div>
              <div className="item-wrapper d-flex mr--5 align-items-center">
                <button className="cart-delete-btn" onClick={() => removeItem(cart_key)}>
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
})}
      </div>

      <div className="cart-bottom-area">
        <span className="total-price">
          TOTAL: <span className="price">${totalPrice.toFixed(2)}</span>
        </span>
        <a href="/cart" className="view-btn cart-btn">
          VIEW CART
        </a>
      </div>
    </div>
   </>,
    document.body
  );
}